import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Button, Card, CardBody, CardHeader, CardText, CardTitle, Col, Form, Row } from 'reactstrap'
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle } from '../../../../../components/Component'
import { WEBSITE_BASE_URL } from '../../../../../config'
import ToastExample from '../../../../../helpers/toast'
import Content from '../../../../../layout/content/Content'
import Head from '../../../../../layout/head/Head'
import { getAllStores } from '../../../../../redux/admin/store/action'
import { getSingleUser, manageStoreOwner } from '../../../../../redux/admin/user/action'
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../../redux/common/actions'
import "./managestore.css"

function ManageStore() {

    const dispatch = useDispatch();

    const getSelectors = (state) => ({
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,
        user: state.users.single_user,
        stores: state.store.stores,
    });

    const { user, stores, form_loading, form_submission_status } = useSelector(getSelectors);

    const { id } = useParams();

    // toggle manage btn
    const [active, setActive] = useState(false)

    // save store id on click
    const [storeId, setStoreID] = useState("")


    const [showToast, setShowToast] = useState(false)

    // get all stores and user data
    useEffect(() => {

        dispatch(getAllStores())
        dispatch(getSingleUser(id))

    }, [])

    const toggleManage = () => {
        dispatch(nonActiveFormSubmissionStatus());
        setActive(!active)

    }

    useEffect(() => {
        if (active == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getSingleUser(id))
                setShowToast(true)
            }, 500);

            setTimeout(() => {

                setShowToast(false)
            }, 3000);
        }
    }, [active, form_loading, form_submission_status])

    const onFormSubmit = (e) => {
        e.preventDefault();
        dispatch(openFormLoading());
        dispatch(manageStoreOwner(id, storeId))

    }
    return (
        <React.Fragment>
            <Head title="Manage Store Owner"></Head>
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Manage Store Owners
                            </BlockTitle>

                        </BlockHeadContent>
                        <BlockHeadContent>
                            <ToastExample show={showToast} />

                        </BlockHeadContent>

                    </BlockBetween>
                </BlockHead>
                <Card className="card-bordered">

                    <CardBody className="card-inner">
                        <CardTitle tag="h5">{user?.name} Store</CardTitle>
                        <CardText>
                            {user?.name} is the owner of the store
                        </CardText>
                        <Button color="primary" onClick={() => toggleManage()}>Manage</Button>
                    </CardBody>

                </Card>

                {active &&
                    <Block>
                        <Row>
                            <div className="col-12">
                                <Form onSubmit={(e) => onFormSubmit(e)}>
                                    <Row className='mt-2'>
                                        {stores?.map((store) => (
                                            <Col lg="3" md="3">
                                                <Card className='rounded-pill' onClick={() => setStoreID(store?.id)}>
                                                    <div id='special-checkboxes'>
                                                        <input className="inputCheck" data-name={store?.name}
                                                            name="user_restaurants" value={"cb" + store?.id}
                                                            style={{ visibility: 'hidden' }} checked={user?.stores && user?.stores[0] && user?.stores[0]?.id === store?.id ? "checked" : null} type="radio" id={"cb" + store?.id} />
                                                        <label htmlFor={"cb" + store?.id} className="text-center " id='check-label'>

                                                            <img src={ store?.image}
                                                                alt={store?.name} className="img img-responsive "
                                                                style={{ borderRadius: "10px", height: "150px", width: "150px", objectFit: "cover" }} />
                                                        </label>
                                                    </div>


                                                    <h5 className="text-center font-bold mb-2">
                                                        {store?.name}

                                                    </h5>

                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                    <div className='d-flex justify-content-end'>

                                        <Button color="primary" size='lg' type='submit'>Update</Button>
                                    </div>
                                </Form>
                            </div>
                        </Row>

                    </Block>

                }
            </Content>
        </React.Fragment>
    )
}

export default ManageStore
